import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      sections.forEach((section, index) => {
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;

        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          setActiveSection(index);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      {/* Fixed Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo" onClick={() => scrollToSection("home")}>
            IHG
          </div>
          <div className="nav-menu">
            <button
              onClick={() => scrollToSection("home")}
              className="nav-link"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="nav-link"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection("goals")}
              className="nav-link"
            >
              Goals
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="nav-link"
            >
              Contact
            </button>
          </div>
        </div>
      </nav>

      {/* Section 1: Landing Page */}
      <section id="home" className="section section-1">
        <div className="content-wrapper">
          <div className="hero-content">
            <h1 className="main-title">
              InnovateHer <span className="pink-text">Georgia</span>
            </h1>
            <div className="title-underline"></div>
            <p className="hero-subtitle">
              Empowering the next generation of girls in tech
            </p>
            <p className="hero-description">
              IHG is a youth-led initiative created to inspire and educate girls
              in Georgia through modern technology, AI/ML fundamentals, and real
              hands-on projects. Our mission is simple: make tech accessible,
              inspiring, and possible for every girl.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2: About Founder */}
      <section id="about" className="section section-2">
        <div className="content-wrapper">
          <div className="section-content">
            <h2 className="section-heading">
              About the <span className="pink-text">Founder</span>
            </h2>
            <h3 className="founder-title">Elene Izoria</h3>
            <div className="text-content">
              <p>
                Hi, I'm Elene — AI/ML learner, young innovator, and founder of
                InnovateHer Georgia. I've been learning programming, machine
                learning, UI/UX, and building my own tech projects and startups.
                Along the way, I realized something important: girls in Georgia
                deserve more opportunities in tech — real education, mentorship,
                and confidence.
              </p>
              <p>
                IHG was born from that belief. Today, I'm building a space where
                girls can explore coding, AI, and creativity with guidance,
                clarity, and support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Goals */}
      <section id="goals" className="section section-3">
        <div className="content-wrapper">
          <div className="section-content">
            <h2 className="section-heading">
              Our <span className="pink-text">Goal</span>
            </h2>
            <p className="intro-text">At IHG, we aim to:</p>

            <div className="goals-list">
              <div className="goal-item">
                <div className="goal-number">01</div>
                <div className="goal-text">
                  <h4>Modern Technologies</h4>
                  <p>
                    Introduce girls to AI/ML, Python, and modern technologies
                  </p>
                </div>
              </div>

              <div className="goal-item">
                <div className="goal-number">02</div>
                <div className="goal-text">
                  <h4>Build Confidence</h4>
                  <p>Build confidence through simple, practical lessons</p>
                </div>
              </div>

              <div className="goal-item">
                <div className="goal-number">03</div>
                <div className="goal-text">
                  <h4>School Workshops</h4>
                  <p>Create workshops in schools across Georgia</p>
                </div>
              </div>

              <div className="goal-item">
                <div className="goal-number">04</div>
                <div className="goal-text">
                  <h4>Real Opportunities</h4>
                  <p>
                    Connect students with real opportunities, events, and
                    competitions
                  </p>
                </div>
              </div>

              <div className="goal-item">
                <div className="goal-number">05</div>
                <div className="goal-text">
                  <h4>Inspire & Empower</h4>
                  <p>
                    Inspire girls to dream bigger and step into the tech world
                    with purpose
                  </p>
                </div>
              </div>
            </div>

            <p className="closing-text">
              We believe that every girl deserves access to technology
              education, no matter her background, school, or experience level.
            </p>
          </div>
        </div>
      </section>

      {/* Section 4: Contact */}
      <section id="contact" className="section section-4">
        <div className="content-wrapper">
          <div className="section-content cta-content">
            <h2 className="section-heading">
              Bring IHG to Your <span className="pink-text">School</span>
            </h2>
            <p className="cta-text">
              If you want an IHG workshop at your school — interactive,
              beginner-friendly, and inspiring — we'd love to visit.
            </p>
            <a href="mailto:ihg.georgia@gmail.com" className="email-button">
              ihg.georgia@gmail.com
            </a>
            <p className="final-message">
              Together, we can build the next generation of innovators.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
